import { useState, useCallback } from 'react'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { motion } from 'framer-motion'
import { useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import { ErrorMessage } from './error-message'
import { resetPassword } from '../authed/auth.actions'
import * as SnackbarActions from '../global/snackbar/snackbar.actions'
import { t } from '@lingui/core/macro'

const marginRight = css`
  margin-right: 8px;
`

const FloatRight = styled.div`
  float: right;
  padding-top: 12px;
`
const TextFieldMarginTop = styled(TextField)`
  margin-top: 12px;
`

export const ConfirmPasswordReset = () => {
  const history = useHistory()
  // const location = useLocation()
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const token = useParams()
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  // const userInitiated = useMemo(() => new URLSearchParams(location.search).get('userInitiated'))

  const handleSubmit = useCallback(
    e => {
      e.preventDefault()
      setLoading(true)
      resetPassword({ password, password_confirmation: confirmPassword, token })
        .then(() => {
          dispatch(
            SnackbarActions.showSnackbar({
              message: 'Your password was successfully reset. Please login above.',
              type: 'SUCCESS',
            }),
          )
          setLoading(false)
          let url = '/auth/login'
          if (location.href.includes('login=system')) {
            url += '?login=system'
          }
          history.push(url)
        })
        .catch(err => {
          setLoading(false)
          dispatch(
            SnackbarActions.showSnackbar({
              message: ErrorMessage(err),
              type: 'ERROR',
            }),
          )
        })
    },
    [password, confirmPassword, token, dispatch, history],
  )

  return (
    <motion.div
      className="ConfirmResetPassword"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      exit={{ opacity: 0, transition: { duration: 0.5 } }}
    >
      <Typography variant="h4">{t`Reset password`}</Typography>
      <Typography variant="body2">
        Passwords must be at least 12 characters and contain letters and numbers.
      </Typography>
      <form onSubmit={handleSubmit}>
        <div>
          <TextFieldMarginTop
            variant="outlined"
            value={password}
            onChange={({ target: { value } }) => setPassword(value)}
            type={showPassword ? 'text' : 'password'}
            label={t`Password`}
            fullWidth={true}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    aria-label="toggle password visibility"
                    onClick={() => {
                      setShowPassword(prev => !prev)
                    }}
                    size="large"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextFieldMarginTop
            variant="outlined"
            value={confirmPassword}
            onChange={({ target: { value } }) => setConfirmPassword(value)}
            type={showConfirm ? 'text' : 'password'}
            label={t`Confirm password`}
            fullWidth={true}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    aria-label="toggle password visibility"
                    onClick={() => {
                      setShowConfirm(prev => !prev)
                    }}
                    size="large"
                  >
                    {showConfirm ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>
        <FloatRight>
          <Button
            disableElevation={true}
            css={marginRight}
            onClick={() => history.push('/auth/login')}
          >
            {t`Cancel`}
          </Button>
          <Button
            disableElevation={true}
            variant="contained"
            color="primary"
            disabled={loading}
            type="submit"
          >
            {t`Save password`}
          </Button>
        </FloatRight>
      </form>
    </motion.div>
  )
}
